class NewLayout {
    constructor() {
      this.$el = $('.new-header');
  
      this.ui = {
        $toggle: $('.new-navbar__toggle', this.$el),
        $navbarCollapse: $('.new-navbar-mobile', this.$el),
        $navRightSide: $('.new-header__right-side', this.$el),
        $navBarContainer: $('.new-header__container', this.$el),
      };
  
      this.state = {
        navbarDisplay: false,
      };
  
      this.ui.$toggle.on('click', this.toggleNavbar.bind(this));
    }

  
    toggleLang(){
      const ddMenu = document.querySelectorAll('.header-submenu__drop-down-menu')
  
      if(ddMenu.length > 0){
        let i;
        for (i = 0; i < ddMenu.length; i++) {
          ddMenu[i].classList.toggle('header-submenu__drop-down-menu__show')
        }
      }
    }
  
    toggleNavbar() {
      // for iPhone
      document.documentElement.classList.toggle('prevent-scroll-header-menu');
      document.body.classList.toggle('prevent-scroll-header-menu');

      this.state.navbarDisplay = !this.state.navbarDisplay;

      this.ui.$navbarCollapse.toggleClass('new-navbar-mobile__show', this.state.navbarDisplay);
      this.ui.$navBarContainer.toggleClass('header__container__show', this.state.navbarDisplay);
    }
  }
  
  export default new NewLayout();
  